// assets
import { BookOutlined, CalculatorOutlined, DollarCircleOutlined, ShoppingCartOutlined } from '@ant-design/icons';

// icons
const icons = {
  BookOutlined,
  CalculatorOutlined,
  DollarCircleOutlined,
  ShoppingCartOutlined
};

// ==============================|| MENU ITEMS - FINANCEIRO ||============================== //

const financeiro = {
  id: 'financeiro',
  title: 'Financeiro',
  type: 'group',
  children: [
    {
      id: 'compras',
      title: 'Compras',
      type: 'item',
      url: '/compras',
      icon: icons.ShoppingCartOutlined
    },
    {
      id: 'financeiro-listagem',
      title: 'Financeiro',
      type: 'item',
      url: '/financeiro',
      icon: icons.DollarCircleOutlined
    },
    {
      id: 'livro-caixa',
      title: 'Livro Caixa',
      type: 'item',
      url: '/livro-caixa',
      icon: icons.BookOutlined
    },
    {
      id: 'simulador',
      title: 'Simulador',
      type: 'item',
      url: '/simulador',
      icon: icons.CalculatorOutlined
    }
  ]
};

export default financeiro;
